
import barba from '@barba/core';
import gsap from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";
import anime from 'animejs';

import Swiper, {  Autoplay, EffectFade, EffectCreative } from 'swiper';

import 'swiper/swiper-bundle.min.css'

Swiper.use([ Autoplay, EffectFade, EffectCreative]);

export default class{

	constructor(){
        this.scrollTriggerItems = []
        barba.hooks.beforeOnce((data) => {
            const index = data.next.container.querySelector("#p-index")
            if(index){

                const header = document.querySelector("#l-header")
                header.classList.add("-in-white")
            }
            // this.headerInview()
        })
        barba.hooks.once((data) => {
            const index = data.next.container.querySelector("#p-index")
            if(index){
                this.init()
                this.intro(true)
            }
        })

        barba.hooks.afterLeave((data) => {
            this.scrollTriggerItems.forEach(t => {
                t.kill()
            })
        })
        barba.hooks.enter((data) => {
            const index = data.next.container.querySelector("#p-index")
            if(index){
                this.init()
            }
        });
        barba.hooks.afterEnter((data) => {
            const index = data.next.container.querySelector("#p-index")
            if(index){
                const header = document.querySelector("#l-header")
                header.classList.add("-in-white")
            }
        })

        barba.hooks.after((data) => {
           
            this.intro(false)
        })
    }
    init (){
        this.triggers()
        this.heroOutView()
    }

    intro(isOnce){
        let wait = 0
        const timelime = anime.timeline()
        
        new Swiper ('.js-about-slider',{
            loop: true,
            // effect: 'creative',
            // creatvieEffect: {
            //     prev: {
            //         translate: ["100%",0,0],
            //     },
            //     next: {
            //         translate: ["-10%", 0, -1],
            //     },
            // },
            speed:2000,
            allowTouchMove :false,
            simulateTouch:false,
            autoplay: {
                delay: 3000,
            },
        })
        if(isOnce){
            wait = 2000
        }
        new Swiper ('.p-index-hero__slider',{
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed:2000,
            allowTouchMove :false,
            simulateTouch:false,
            autoplay: {
                delay: 5000,
            },
        })
        timelime.add({
            targets:[".p-index-hero__en .p-index-hero__en-l1 span"],
            translateY : ["120%",0],
            easing: 'easeOutExpo',
            duration : 1200
        },wait)
        .add({
            targets:[".p-index-hero__en .p-index-hero__en-l2 span"],
            translateY : ["120%",0],
            easing: 'easeOutExpo',
            duration : 1200
        },"-=1000")
        .add({
            targets:[".p-index-hero__jp .p-index-hero__jp-l1 span"],
            translateY : ["120%",0],
            easing: 'easeOutExpo',
            duration : 1200
        },"-=1000")
        .add({
            targets:[".p-index-hero__jp .p-index-hero__jp-l2 span"],
            translateY : ["120%",0],
            easing: 'easeOutExpo',
            duration : 1200
        },"-=1000")
        .add({
            targets:[".p-index-hero__jp .p-index-hero__jp-l3 span"],
            translateY : ["120%",0],
            easing: 'easeOutExpo',
            duration : 1200
        },"-=1000")
        
    }
    triggers(){

        // ScrollTrigger.create({
        //     trigger: '#p-index-hero__image',
        //     scroller: "[data-scroll-container]",
        //     start: 'top top',
        //     end: 'bottom top',
        //     pin: true,
        // });

        // gsap.to(
        //     ".p-index-wedo__looptext",
        //     {
        //         x:"-25%",
        //         scrollTrigger: {
        //             trigger: "#p-index-wedo",
        //             scroller: "[data-scroll-container]",
        //             start: 'top top',
        //             end: 'bottom top',
        //             scrub:true
        //         }
        //     }
        // );
        
        
        // gsap.fromTo(
        //     ".p-index-product__cover-section.-primary .p-index-product__cover--bg",
        //     {
        //         scale:.90,
        //     },
        //     {
        //         scale:1,
        //         scrollTrigger: {
        //             trigger: ".p-index-product__cover",
        //             scroller: "[data-scroll-container]",
        //             start: 'top top',
        //             end: 'center top',
        //             scrub:true,
        //             toggleClass: { targets: ".p-index-product__floating", className: "is-scroll" }
        //         }
        //     }
        // );

        // this.scrollTriggerItems.push(
        //     ScrollTrigger.create({
        //         trigger: ".p-index-product__cover",
        //         scroller: "[data-scroll-container]",
        //         start: 'top top',
        //         end: 'bottom top',
        //         scrub:true,
        //         pin:true,
        //         pinnedContainer: ".p-index-product__cover-section.-primary",
        //     })
        // )


        // gsap.fromTo(
        //     ".p-index-product__cover-section.-secondary .p-index-product__cover--bg",
        //     {
        //         y:"0",
        //     },
        //     {
        //         y:"-100vh",
        //         scrollTrigger: {
        //             trigger: ".p-index-product__cover-section.-secondary",
        //             scroller: "[data-scroll-container]",
        //             start: 'top top',
        //             end: 'bottom top',
        //             scrub:true,
        //             toggleClass: { targets: ".p-index-product__floating", className: "is-scroll" }
        //         }
        //     }
        // );
    }
    headerInview(){
        // const callback = (entries) => {
        //     entries.forEach( (entry) => {
        //         const ratio = Math.round(entry.intersectionRatio*100)
        //         const header = document.querySelector("#l-header")
        //         if (entry.isIntersecting) {
        //             header.classList.add("-in-white")
        //         }else{
        //             header.classList.remove("-in-white")
        //         }
        //     });
        // }
        // const observerOptions = {
        //     rootMargin: "0px 0px 0px 0px",
        //     threshold: 0
        // }
        // this.observer = new IntersectionObserver(callback, observerOptions)
        // const sections = document.querySelectorAll('[data-header-toggle]')
        // if( sections.length > 0 ){
        //     sections.forEach( el => { 
        //         this.observer.observe(el)
        //     })
        // }
        
    }
    heroOutView(){
        // const callback = (entries) => {
        //     entries.forEach( (entry) => {
        //         if (entry.isIntersecting) {
        //             header.classList.remove("-over-fv")
        //         }else{
        //             header.classList.add("-over-fv")
        //         }
        //     });
        // }
        // const observerOptions = {
        //     rootMargin: "0px 0px 0px 0px",
        //     threshold: [0,1]
        // }
        // this.observer = new IntersectionObserver(callback, observerOptions)
        // const sections = document.querySelectorAll('[data-hero]')
        // if( sections.length > 0 ){
        //     sections.forEach( el => { 
        //         this.observer.observe(el)
        //     })
        // // }
        // const header = document.querySelector("#l-header")
        // ScrollTrigger.create({
        //     trigger: "[data-hero]",
        //     scroller: "[data-scroll-container]",
        //     start: 'top top',
        //     end: 'bottom top',
        //     onEnter :() => {
        //         header.classList.add("-over-fv")
        //     },
        //     onEnterBack:() => {
        //         header.classList.add("-over-fv")
        //     },
        //     onLeave:() => {
        //         header.classList.remove("-over-fv")
        //     },
        //     onLeaveBack:() => {
        //         header.classList.remove("-over-fv")
        //     },
        // });
        
    }
}